export const VIEW_MEMBERS_ASSESSMENT = "VIEW_MEMBERS_ASSESSMENT";
export const SET_COMMENT_STORE = "SET_COMMENT_STORE";
export const SET_COMMENT = "SET_COMMENT";
export const SET_TOPIC_ROLE = "SET_TOPIC_ROLE";